@for (segment of segments; track $index) {
    @if (segment.link) {
        <a
            class="text-link"
            [routerLink]="segment.link"
            (click)="onLinkClick($event)"
            >{{ segment.text }}</a
        >
    } @else {
        <span>{{ segment.text }}</span>
    }
}
